<template>
  <div>
    <form @submit.prevent="submit">
      <!-- <p class="text-black-50 mb-2">Acesse com:</p> -->

      <!-- <p class="text-black-50 mt-4">Se você tem uma conta no <strong>{{ api.settings.title }}</strong> ou na <strong>99jobs.com</strong> acesse com:</p> -->

      <div class="form-group">
        <FloatingLabel type="email" input-class="form-control form-control-xl bg-light-2 border-0" label="E-mail" v-model="email" v-if="loginType == 'email'" />
        <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" label="CPF" v-model="document" v-if="loginType == 'cpf'" v-mask="'###.###.###-##'" />
        <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" label="Matrícula" v-model="unique_id" v-if="loginType == 'matricula'" />
      </div>

      <div class="form-group">
        <FloatingLabel type="password" input-class="form-control form-control-xl bg-light-2 border-0" label="Senha" v-model="password" />
      </div>

      <div class="form-group d-flex mb-5">
        <div class="custom-control custom-checkbox custom-checkbox-lg custom-checkbox-background">
          <input type="checkbox" class="custom-control-input" id="keep-logged" v-model="keepLogged">
          <label class="custom-control-label" for="keep-logged">Lembrar de mim</label>
        </div>

        <div class="d-flex flex-column ml-auto text-right">
          <a href="#" class="text-wl-secondary font-weight-bold semi-small" @click.prevent="$emit('changeModal', 'password')"><u>Esqueci minha senha</u></a>
          <!-- <a href="#" class="text-wl-secondary font-weight-bold semi-small mt-1" @click.prevent="$emit('changeModal', 'forgotUser')"><u>Esqueci meu e-mail</u></a> -->
        </div>
      </div>

      <div class="text-center">
        <!-- <a href="#" class="text-wl-secondary font-weight-bold mr-3" @click.prevent="$emit('changeModal', 'preRegister')">Ainda não tenho cadastro</a> -->
        <button type="submit" class="btn btn-wl-secondary px-4" :disabled="!canSubmit">Entrar</button>
      </div>
    </form>
  </div>
</template>

<script>
  import FacebookIcon from "vue-material-design-icons/Facebook.vue"
  import LinkedinIcon from "vue-material-design-icons/Linkedin.vue"
  import FloatingLabel from '@/components/FloatingLabel';

  import api from '@/data.json'

  export default {
    name: 'LoginRIForm',

    data() {
      return {
        email: this.$store.state.deviseTrying.email || '',
        document: this.$store.state.deviseTrying.document || '',
        unique_id: this.$store.state.deviseTrying.unique_id || '',
        password: "",
        keepLogged: false,
        loading: false,
        supported_emails: [],
        loginType: "matricula",
        api: api
      };
    },

    computed: {
      canSubmit() {
        return (
          ((this.loginType == "email" && this.$helpers.isEmail(this.email)) ||
            (this.loginType == "cpf" && this.$helpers.isCPF(this.document)) ||
            (this.loginType == "matricula" && this.unique_id.length > 2)) &&
          this.$helpers.validPassword(this.password)
        );
      },
    },

    components: {
      FacebookIcon,
      LinkedinIcon,
      FloatingLabel
    },

    mounted() {
      this.$store
        .dispatch("user/companyInternalRecruitment", {})
        .then((response) => {
          var data = response.data;

          if (data) {
            var domains = data.companyInternalRecruitment.domains;

            this.loginType = data.companyInternalRecruitment.loginType;

            if (domains.length > 0) {
              this.supported_emails =
                data.companyInternalRecruitment.domains.split(";");
            }
          }
        });
    },

    methods: {
      submit(){
        this.loading = true;
        let current_profile = this.$store.state.deviseTrying;
        current_profile.email = this.email;
        current_profile.document = this.document;
        current_profile.unique_id = this.unique_id;
        current_profile.password = this.password;
        current_profile.keepLogged = this.keepLogged;
        current_profile.provider = null;
        current_profile.id = null;
        this.$store.commit("DEVISE_TRYING", current_profile);

        this.$emit('signIn');
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>